(function ($) {
	$('.woocommerce-cart-form').on('change', 'input.cart-item-comment', function () {
		const cartItemKey = $(this).attr("data-cart-item-key");
		const comment = $(this).val();

		$.ajax({
			type: "post",
			url: window.wc_add_to_cart_params.ajax_url,
			datatype: 'json',
			data: {
				action: "update_custom_cart_comment",
				cart_item_key: cartItemKey,
				comment: comment,
			},
			success: function (res) {
				console.log(res)
			}
		})
	})

	// Update cart automatically on quantity change
	const delay = 500;
	let timeout;

	$('.woocommerce').on('change', 'input.qty', function () {
		if (timeout !== undefined) {
			clearTimeout(timeout);
		}
		timeout = setTimeout(function () {
			$('[name="update_cart"]').trigger('click');
		}, delay);
	});
})(jQuery);
